import React, { useEffect, useState } from "react";

import { Card, Segment, Statistic } from "semantic-ui-react";

import useProductParser from "hooks/useProductParser";

import { format, subDays } from "date-fns";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

function TrendingProducts() {
	const [trendingProducts, setTrendingProducts] = useState([
		{ productId: "1", quantitySold: "-" },
		{ productId: "2", quantitySold: "-" },
		{ productId: "3", quantitySold: "-" },
	]);

	useEffect(() => {
		const getTrendingProducts = async (startDate, endDate) => {
			try {
				const response = await http.get("/report/products/trending", {
					params: { startDate, endDate },
				});

				const records = response.data?.records ?? [];
				if (records.length < 3) {
					let recordCount = records.length;
					while (records.length < 3) {
						recordCount += 1;
						records.push({
							productId: recordCount,
							quantitySold: "-",
						});
					}
				}

				setTrendingProducts(records);
			} catch (ex) {
				Alerts.httpException(ex);
			}
		};

		const today = format(new Date(), "yyyy-MM-dd");
		const tomorrow = format(subDays(new Date(), -1), "yyyy-MM-dd");

		getTrendingProducts(today, tomorrow);
	}, []);

	const { parseProductName } = useProductParser();

	const getFormattedProductName = (productId) => {
		const productName = parseProductName(productId);
		return productName.length <= 16
			? productName
			: `${productName.substr(0, 19)}...`;
	};

	return (
		<Segment style={{ backgroundColor: "#3d3d3d" }}>
			<p style={{ color: "white" }}>
				Trending Products{" "}
				<span
					style={{
						color: "whitesmoke",
						fontSize: "11px",
					}}
				>
					(Quantities sold today)
				</span>
			</p>
			<Card.Group itemsPerRow={3}>
				{trendingProducts.map((item) => (
					<Card key={item.productId}>
						<Segment textAlign="center" padded="very">
							<Statistic
								size="small"
								label={getFormattedProductName(item.productId)}
								value={item.quantitySold}
							/>
						</Segment>
					</Card>
				))}
			</Card.Group>
		</Segment>
	);
}

export default TrendingProducts;
